export const findDraggingPlaceholderElement = (
  droppableElement: HTMLElement,
  draggableId: string,
): HTMLElement =>
  droppableElement.querySelector(`[data-draggableplhid="${draggableId}"]`);
